import { Link } from 'expo-router';
import { StyleSheet, Text, View } from 'react-native';

import { PublicPageShell } from '@/src/components/PublicPageShell';
import { colors } from '@/src/theme/colors';
import { spacing } from '@/src/theme/spacing';

export default function DataDeletionScreen() {
  return (
    <PublicPageShell
      title="Data deletion"
      subtitle="How to request deletion of your Frienzzi account and information."
    >
      <View style={styles.panel}>
        <Text style={styles.heading}>From the app</Text>
        <Text style={styles.copy}>
          Sign in, open Profile, go to Settings, and use Delete account. This
          schedules your account for deletion and gives you 30 days to cancel.
        </Text>
      </View>
      <View style={styles.panel}>
        <Text style={styles.heading}>Facebook Login users</Text>
        <Text style={styles.copy}>
          If you used Facebook Login, you can also request deletion through
          Meta. Meta sends Frienzzi a signed data deletion callback and we
          return a confirmation code plus a status URL.
        </Text>
        <Text style={styles.copy}>
          Callback URL:{' '}
          <Text style={styles.monospace}>
            https://frienzzi.com/facebook/data-deletion
          </Text>
        </Text>
      </View>
      <View style={styles.panel}>
        <Text style={styles.heading}>What is deleted</Text>
        <Text style={styles.copy}>
          Permanent deletion removes your Firebase Auth account, private
          profile, public profile, legal acceptance records, notifications,
          follow relationships, owned posts and comments, post reactions,
          comment reactions, legacy likes, uploaded media, generated thumbnails,
          and generated profile image variants. Frienzzi keeps only a minimal
          non-PII deletion audit with the confirmation code, status, request
          time, and completion time.
        </Text>
      </View>
      <Text style={styles.copy}>
        Questions can be sent to{' '}
        <Link href="mailto:support@frienzzi.com" style={styles.link}>
          support@frienzzi.com
        </Link>
        .
      </Text>
    </PublicPageShell>
  );
}

const styles = StyleSheet.create({
  panel: {
    backgroundColor: colors.surface,
    borderColor: colors.border,
    borderRadius: 8,
    borderWidth: 1,
    gap: spacing.md,
    padding: spacing.lg,
  },
  heading: {
    color: colors.text,
    fontSize: 18,
    fontWeight: '900',
  },
  copy: {
    color: colors.text,
    fontSize: 15,
    lineHeight: 22,
  },
  link: {
    color: colors.primary,
    fontWeight: '800',
  },
  monospace: {
    color: colors.text,
    fontFamily: 'Courier',
    fontSize: 14,
  },
});
